import React, { ReactElement, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';

import { Bundle } from '../../../redux';
import {
	DialogWindow,
	DialogWindowHeader,
	BundleSelector,
	DialogWindowFooter
} from '..';

import './select-bundle-dialog.styles.scss';
import { useTranslation } from 'react-i18next';

export interface ISelectBundleDialogProps {
	bundles: Bundle[];
	open: boolean;
	onClose: () => void;
	onSelect: (bundle: Bundle[]) => void;
}

export function SelectBundleDialog(
	props: ISelectBundleDialogProps
): ReactElement {
	const { bundles, open, onClose, onSelect } = props;
	const { t } = useTranslation(['folder', 'general']);

	const [selectedBundles, setSelectedBundles] = useState<Bundle[]>(bundles);

	useEffect(() => {
		setSelectedBundles(bundles);
	}, [bundles]);

	return (
		<DialogWindow
			className="select-bundle-dialog"
			open={open}
			onClose={onClose}
		>
			<DialogWindowHeader
				title={t('folder:selectFolder')}
				onClose={onClose}
			/>
			<Box className="select-bundle-dialog-content">
				<BundleSelector
					selectedBundles={selectedBundles}
					onChange={setSelectedBundles}
				/>
			</Box>
			<DialogWindowFooter
				onConfirm={() => onSelect(selectedBundles)}
				onCancel={onClose}
				confirmText={t('general:dialog.select')}
				disableConfirm={selectedBundles.length === 0}
			/>
		</DialogWindow>
	);
}
